// authHOC.tsx
import { useRouter } from "next/router";
import { useEffect } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../services/hooks/useReduxHooks";
import {
  LoadingActionEnum,
  increasePendingOperations,
  pushToLoadingStack,
  setLoading,
} from "../../../services/redux/slices/globalComponentsToggleSlice";
import { getCookie } from "../../../utils/CookieHelper";
import { COOKIE_ENUM, PagesEnum, RouteTypesEnum } from "../../../utils/enums";
import { getPageLink } from "../../../utils/help/navigation/navigation";
import { isVisitor } from "../../../utils/help/user/user";
import { getRouteType } from "../../../utils/routeConfig";

const authHOC = (WrappedComponent: any) => {
  // The returned component also needs to accept the same props
  const AuthComponent = (props: any) => {
    const router = useRouter();
    const customerCookie = getCookie(COOKIE_ENUM.TOKEN);
    const dispatch = useAppDispatch();
    const restaurantConfig = useAppSelector(
      (state) => state.config.restaurantInfo
    )?.config;

    const routeType = getRouteType();

    useEffect(() => {
      switch (routeType) {
        case RouteTypesEnum.CUSTOMERS_ONLY:
          if (isVisitor()) {
            router.push(
              `${getPageLink(router, PagesEnum.Login).href}`,
              `${getPageLink(router, PagesEnum.Login).as}`
            );
            if (restaurantConfig?.loadingStateSolution) {
              dispatch(
                pushToLoadingStack({
                  action: LoadingActionEnum.INCREASE,
                  functionName: "authHOC customersOnly",
                  date: new Date(),
                })
              );
              dispatch(increasePendingOperations());
            } else {
              dispatch(setLoading(true));
            }
          }
          break;
        case RouteTypesEnum.VISTORS_ONLY:
          if (!isVisitor() && customerCookie) {
            if (!restaurantConfig?.signUpFeature) {
              console.log("router push 4th", router, PagesEnum.Home);
              router.push(
                `${getPageLink(router, PagesEnum.Home).href}`,
                `${getPageLink(router, PagesEnum.Home).as}`
              );
            }
            if (restaurantConfig?.loadingStateSolution) {
              dispatch(
                pushToLoadingStack({
                  action: LoadingActionEnum.INCREASE,
                  functionName: "authHOC visitorsOnly",
                  date: new Date(),
                })
              );
              dispatch(increasePendingOperations());
            } else {
              dispatch(setLoading(true));
            }
          }
          break;
        case RouteTypesEnum.ALL_USERS:
        default:
          break;
      }
    }, [router, routeType]);

    return <WrappedComponent {...props} />;
  };

  return AuthComponent;
};

export default authHOC;
